import React from 'react';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import aku from './aku.png';
import ListGroup from 'react-bootstrap/ListGroup';
import Tab from 'react-bootstrap/Tab';
import jogaSiva from './images/joga_siva.png';
import jogaKazdy from './images/joga_dla_kazdego_wht.png';
import jogaCiaza from './images/joga_ciaza.png';
import welcome from './images/welcome.jpg';
import akupunktura from './images/akupunktura.jpg';
import oMnieBio from './images/o_mnie.jpg';
import FadeIn from './FadeIn';


function App() {


  return (
    <div className="App">
      <header className="App-header">
      </header>
      <FadeIn>
      <Container className='hero-title'>
        <Row>
          <Col xs={12} md={12}>
            <p className='tagline'>Akupunktura oraz kameralne zajęcia jogi sprzyjające zdrowiu, redukcji napięć i naturalnej regeneracji organizmu.</p>
          </Col>
        </Row>
      </Container>
      </FadeIn>
      <FadeIn>
      <Container className='about-section' id='o-mnie'>
        <Row>
          <Col xs={12} md={6} className='about-img'>
            <img src={welcome} alt="Weronika Kulczyńska-Trzeciak" />
          </Col>
          <Col xs={12} md={6}>
            <p><span className='intro-lead'><strong>Powrót do siebie i naturalnej równowagi</strong></span><br></br><span>
Akupunktura pomaga organizmowi uruchomić jego własne procesy regeneracji i powrotu do równowagi.

Igły są jedynie delikatnym impulsem, który nakierowuje na te obszary, które wymagają wsparcia.  

Zdrowie to coś więcej niż brak objawów — to stan, w którym możesz w pełni rozwijać swój potencjał fizyczny i psychiczny.
<br></br><br></br>
Jeśli czujesz, że to czas na powrót do siebie, zapraszam.
</span></p>
          </Col>

        </Row>
      </Container>
      </FadeIn>

      <FadeIn>
      <Container className='medicine-section' id='welcome-section'>
        <Row>
          <Col xs={12} md={6} className='order-md-2'>
            <h1 className='section-title stacked desktop-only'>
              <span className="g-italic">W CZYM<br></br>MOGĘ</span><br></br>CI POMÓC
            </h1>
            <h1 className='section-title stacked mobile-only'>
              <span className="g-italic">W CZYM MOGĘ</span><br></br>CI POMÓC
            </h1>
          </Col>
          <Col xs={12} md={6} className='order-md-1'>
            <p>Akupunktura jest stosowana jako metoda wspomagająca w wybranych dolegliwościach takich jak:</p>
         <ul className='plain-list'>
              <li>przewlekłe zmęczenie</li>
              <li>bóle mięśni i stawów</li>
              <li>migreny</li>
              <li>wsparcie dobrostanu i redukcja napięcia w okresie przygotowania do leczenia niepłodności i procedur IVF</li>
              <li>dolegliwości związane z cyklem menstruacyjnym, takie jak bolesne miesiączki, objawy PMS</li>
              <li>problemy z układem trawiennym</li>
              <li>napięcie, stres, trudności ze snem</li>
              <li>alergie oraz problemy z układem oddechowym</li>
            </ul>
            <p style={{marginTop: 0}}>Przede wszystkim akupunktura jest narzędziem profilaktyki zdrowia. Akupunktura jest metodą uzupełniającą i nie zastępuje diagnostyki ani leczenia zaleconego przez lekarza. W przypadku występowania objawów wymagających diagnostyki medycznej rekomenduję konsultację z odpowiednim specjalistą.</p>
          </Col>
        </Row>

      </Container>
      </FadeIn>


      <FadeIn>
      <Container className='medicine-section desc' id="chinska">
        <Row>
          <Col xs={12} md={6}>
            <h1 className='section-title stacked desktop-only'>
              <span className="g-italic">MEDY<br></br>CYNA</span><br></br>CHIŃ<br></br>SKA.
            </h1>
            <h1 className='section-title stacked mobile-only'>
              <span className="g-italic">MEDYCYNA</span><br></br>CHIŃSKA.
            </h1>
          </Col>
          <Col xs={12} md={6}>
            <p>Medycyna Chińska - jeden z najstarszych systemów terapeutycznych świata, służy profilaktyce zdrowia oraz przywracaniu naturalnej równowagi organizmu. <br></br>Traktuje człowieka holistycznie – jako całość, w której ciało, umysł i emocje nieustannie na siebie oddziałują.
Zakłada również, że człowiek funkcjonuje w ścisłym powiązaniu z otaczającą go przyrodą, porami roku, klimatem oraz cyklami środowiskowymi.
W pracy z klientem stosuję indywidualną diagnozę opartą na zasadach tradycyjnej medycyny chińskiej w skład której wchodzi: szczegółowy wywiad, badanie pulsu oraz obserwacja języka. Na tej podstawie dobieram punkty akupunkturowe, zalecenia żywieniowe i wskazówki dotyczące stylu życia, aby wzmacniać naturalne procesy równowagi i regeneracji.
            </p>
          </Col>
        </Row>
      </Container>
      </FadeIn>

      <FadeIn>
      <Container id="akupunktura-section" className='service-list-section'>
<Row className='service-section'>
<Row className='services-tabbed'>
<Col sm={6}>
        <h1 className='section-title stacked desktop-only'>
              <span className="g-italic">AKU<br></br>PUNK</span><br></br>TURA.<br></br>
            </h1>
        <h1 className='section-title stacked mobile-only'>
              <span className="g-italic">AKU</span><br></br>PUNKTURA.
            </h1>
        </Col>
        <Col sm={6}>
            <p>Zabieg polega na precyzyjnym wprowadzaniu bardzo cienkich igieł w odpowiednio dobrane punkty na ciele. Terapia poprzedzona jest szczegółową konsultacją oraz diagnostyką, w tym badaniem pulsu, które pozwala określić indywidualne predyspozycje organizmu, jego mocne strony oraz obszary wymagające szczególnej troski.

Na podstawie diagnozy dobieram punkty,  zgodnie z systemem tradycyjnej medycyny chińskiej oddziaływują na przepływ Qi i przywracanie równowagi organizmu. Wiele osób korzystających z akupunktury opisuje poprawę samopoczucia, zmniejszenie napięcia i większy komfort po zabiegach. Reakcja na terapię jest jednak indywidualna.

W trakcie terapii uczymy się słuchać subtelnych sygnałów jakie wysyła nam nasz organizm na co dzień aby móc lepiej odpowiadać na jego potrzeby. Częstotliwość spotkań ustalam indywidualnie, w zależności od celu terapii, charakteru dolegliwości i reakcji organizmu na zabiegi.
            </p>
        </Col>
      </Row>

    </Row>
      </Container>
      </FadeIn>

      <FadeIn>
      <Container className='akupunktura-benefits'>
        <Row>
          <Col xs={12} md={7} className='akupunktura-benefits-img'>
            <img src={akupunktura} alt="Akupunktura" />
          </Col>
          <Col xs={12} md={5} className='akupunktura-benefits-text'>
            <p style={{marginTop: 0}}><span className='border-btm'>W praktyce akupunktura jest najczęściej stosowana jako metoda wspomagająca w dolegliwościach:</span></p>
            <p style={{marginTop: 0}}>
              <span className='border-btm italic'>bóle i napięcia mięśniowo-stawowe – kręgosłup, kark, barki, kolana, bóle po urazach,</span> <br></br>
              <span className='border-btm italic'>bóle głowy i migreny – w tym neuralgia nerwu trójdzielnego,</span> <br></br>
              <span className='border-btm italic'>stres, napięcie i problemy ze snem – lepsza regeneracja i codzienny spokój,</span> <br></br>
              <span className='border-btm italic'>zdrowie kobiet – bolesne miesiączki, PMS, mdłości w ciąży, poprawa płodności,</span> <br></br>
              <span className='border-btm italic'>układ pokarmowy – nudności, wymioty, dolegliwości żołądkowe i jelitowe,</span> <br></br>
              <span className='border-btm italic'>układ oddechowy i alergie – katar sienny, astma, alergie.</span>
            </p>
          </Col>
        </Row>
      </Container>
      </FadeIn>



     {/*  <Container className='joga-foto'>
        <Row>
          <Col xs={12} md={12}>
          <img src={joga} alt="Joga" className='joga-img' />
          </Col>
        </Row>
      </Container>*/}

      <FadeIn>
      <Container id="joga-section" className='service-list-section orange'>
        <Row className='service-section'>
            <Col xs={12} md={6}>
            <h1 className='section-title'>
              JOGA.
            </h1>
          </Col>
    <Tab.Container id="list-group-tabs-example" defaultActiveKey="#joga-siva">
      <Row className='services-tabbed'>
        <Col sm={6}>
          <ListGroup className='service-listgroup'>
            <ListGroup.Item action href="#joga-siva">
            <h3 className='service section-title stacked'>
            <span className='top-word withphoto'><img src={jogaSiva} alt="Joga dla każdego" />JOGA.</span> <span className="g-italic">DLA KAŻDEGO</span>
            </h3>
            </ListGroup.Item>
            <ListGroup.Item action href="#joga-dla-kazdego">
            <h3 className='service section-title stacked'>
            <span className='top-word withphoto'><img src={jogaKazdy} alt="Joga Sivananda" />ZAJĘCIA.</span> <span className="g-italic">DLA SENIORÓW</span>
            </h3>
            </ListGroup.Item>
            <ListGroup.Item action href="#joga-dla-kobiet-w-ciazy">
            <h3 className='service section-title stacked'>
            <span className='top-word withphoto'><img src={jogaCiaza} alt="Joga Sivananda" />ZAJĘCIA.</span> <span className="g-italic">INDYWIDUALNE</span>
            </h3>
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col sm={6}>
          <Tab.Content>
            <Tab.Pane eventKey="#joga-siva">
            <p>Zajęcia przeznaczone są zarówno dla osób początkujących, jak i tych, które chcą pogłębić swoją praktykę.

W trakcie spotkań wykorzystuję różnorodne sekwencje asan ukierunkowane na wzmacnianie, uelastycznianie oraz rozluźnianie poszczególnych partii ciała. Szczególną uwagę poświęcam odbudowywaniu świadomości ciała, oddechu i umysłu. Joga przede wszystkim jest systematyczną praktyką łączącą wymiar cielesny, mentalny, emocjonalny. Pracujemy z poprawą koncentracji, klarowności, stabilności, jest drogą do głębszego poznania siebie.
Moje zajęcia stanowią połączenie mądrości tradycji z nowoczesnym podejściem. Nierzadko pojawiają się elementy ćwiczeń funkcjonalnych, ćwiczeń regulujących układ nerwowy, tradycyjnych asan oraz ćwiczeń oddechowych (pranajamy). Zajęcia odbywają się w kameralnych grupach, co pozwala na indywidualne podejście do potrzeb każdego uczestnika oraz bezpieczne dostosowanie praktyki do jego możliwości.</p>
            </Tab.Pane>
            <Tab.Pane eventKey="#joga-dla-kazdego">
            <p>Łagodne i bezpieczne zajęcia stworzone z myślą o osobach starszych, które chcą zadbać o sprawność, równowagę oraz dobre samopoczucie.

Podczas zajęć skupiamy się na poprawie mobilności stawów, wzmocnieniu mięśni, pracy z oddechem oraz ćwiczeniach poprawiających równowagę i koordynację.

Praktyka pomaga zmniejszyć napięcia, poprawić postawę oraz zwiększyć komfort codziennego funkcjonowania.

Ćwiczenia są dostosowane do indywidualnych możliwości uczestników i prowadzone w spokojnym tempie, z uwagą na bezpieczeństwo wykonywanych ćwiczeń.</p> 
            </Tab.Pane>
            <Tab.Pane eventKey="#joga-dla-kobiet-w-ciazy">
            <p>Możliwość dostosowania praktyki do Twoich potrzeb, celów oraz ograniczeń zdrowotnych — w dogodnym dla Ciebie terminie, w domowym zaciszu lub w moim gabinecie.
Cena ustalana jest indywidualnie.

            </p>
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
         
        </Row>
      </Container>
      </FadeIn>

    {/*  <Container className='schedule' id='grafik'>
        <Row>
                <Col md={1}></Col>
                <Col md={10}>
                <h2 className='service section-title stacked'>
                <span className="g-italic swaped">GRAFIK</span><br></br> ZAJĘĆ.<br></br>
            </h2>
                  <Row className='schedule-row'>
                 
                  <Col className='weekday'>
                    <h4>PONIEDZIAŁEK</h4>
                    <h5>9:00 -10:15</h5>
                    <h5>JOGA. SIVANANDA</h5>
                    <h5 className='underline'>Grota Solna Galos</h5>
                    <br></br>
                    <h5>10:30 -11:45</h5>
                    <h5>JOGA. DLA KOBIET W CIĄŻY</h5>
                    <h5 className='underline'>Grota Solna Galos</h5>
                    <br></br>
                    <h5>18:00 -19:15</h5>
                    <h5>JOGA. DLA KAŻDEGO</h5>
                    <h5 className='underline'>Przystanek oddech</h5>
                  </Col>
                  <Col className='weekday' >
                    <h4>WTOREK</h4>
                    <h5>10:30 -11:45</h5>
                    <h5>JOGA. DLA KOBIET W CIĄŻY</h5>
                    <h5 className='underline'>Przystanek oddech</h5>
                    <br></br>
                  </Col>
                  <Col className='weekday' ><h4>ŚRODA</h4></Col>
                  <Col className='weekday' ><h4>CZWARTEK</h4></Col>
                  <Col className='weekday'>
                    <h4>PIĄTEK</h4>
                    <h5>18:00 -19:15</h5>
                    <h5>JOGA. DLA KAŻDEGO</h5>
                    <h5 className='underline'>Przystanek oddech</h5>
                    <br></br>
                    <h5>10:30 -11:45</h5>
                    <h5>JOGA. DLA KOBIET W CIĄŻY</h5>
                    <h5 className='underline'>Przystanek oddech</h5>
                    </Col>
                  </Row>
                
                </Col>
                <Col md={1}></Col>

        </Row>

      </Container>*/}

      <FadeIn>
      <Container className='pricelist' id='cennik'>
        <h1 className='gigantic'>
          CENNIK
        </h1>
        <Row className='pricelist-columns'>
            <Col xs={12} md={12}>
                <h5 className='pricelist-title'>
                  <span className='g-italic'>MEDYCYNA</span> CHIŃSKA
                </h5>
                <Row className='price-list medycyna' >
                  <Col xs={6} md={6}>
                   <h5 className='usluga'>Medycyna Chińska<br></br> 1 wizyta (diagnoza + zabieg akupunktury )</h5>
                  </Col>
                  <Col xs={6} md={6}>
                   <h5 className='cena'>  <br></br> 200zł<br></br>( czas trwania ok 1h)</h5>
                  </Col>
                  </Row>
                  <Row className='price-list medycyna' >
                     <Col xs={6} md={6}>
                      <h5 className='usluga'>Kolejna wizyta</h5>
                    </Col>
                      <Col xs={6} md={6}>
                       <h5 className='cena'> 150zł <br></br>(czas trwania ok 30-40min)</h5>
                      </Col>
                  </Row>
                <h5 className='pricelist-title'>
                  <span className='g-italic'>ZAJĘCIA</span> JOGI
                </h5>
                <Row className='price-list medycyna' >
                  <Col xs={6} md={6}>
                    <h5 className='usluga'> inf. pod nr tel. <a href="tel:609077780">609077780</a></h5>
                  </Col>
                  <Col xs={6} md={6}>
                       <h5 className='cena'>(cennik różni się w zależności od lokalizacji)</h5>
                  </Col>
                </Row>
                  </Col>
        </Row>
      </Container>
      </FadeIn>

      <FadeIn>
      <Container className='medicine-section desc' id='o-mnie-bio'>
        <Row className='o-mnie-bio-top'>
          <Col xs={12} md={7} className='o-mnie-bio-img'>
 
            <img src={oMnieBio} alt="Weronika Kulczyńska-Trzeciak" />
          </Col>
          <Col xs={12} md={5} className='o-mnie-bio-text'>
            <h1 className='section-title special-first'>
              <span className="g-italic">O</span>MNIE.
            </h1>
            <p>Jestem pasjonatką i terapeutką Medycyny Chińskiej (specjalizacja: akupunktura) oraz nauczycielką jogi.</p>
            <p style={{marginTop: 0}}>Skuteczność tych metod obserwuję od lat – na sobie, w swojej rodzinie oraz w pracy z pacjentami. Nieustannie fascynuje mnie to, jak pojedyncza igła wprowadzona w odpowiedni punkt ciała potrafi wywołać zmianę w samopoczuciu fizycznym i psychicznym.</p>
            <p style={{marginTop: 0}}>W swojej pracy łączę doświadczenie obu systemów, aby pomagać organizmowi odzyskiwać naturalną równowagę.</p>
            <p style={{marginTop: 0}}>Szczególnym zainteresowaniem darzę pracę z kobiecym zdrowiem na różnych etapach życia.</p>
            <p style={{marginTop: 0}}>Z satysfakcją obserwuję, jak osoby korzystające z terapii stopniowo odzyskują zdrowie, witalność oraz lepszą zdolność adaptacji organizmu do zmieniających się warunków.</p>

            <p><span className='border-btm'>Edukacja:</span></p>
            <p style={{marginTop: 0}}>
              2012 - Podstawy Medycyny Chińskiej - Instytut Medycyny Chińskiej w Krakowie<br></br>
              2013-2016 - Trójmiejski Ośrodek Medycyny Orientalnej (TOMO) - specjalizacja akupunktura<br></br>
              2014-2015 - Dietetyka wg. 5 Przemian - Agnieszka Krzemińska<br></br>
              2018 - Gotowe receptury ziołowe - Agnieszka Krzemińska<br></br>
              2021 - Level Up „Stems and Branches" - Michał Richter<br></br>
              2022-2023 - Akupunktura Klasyczna - Michał Richter<br></br>
              2025 - Akupunktura wspierająca płodność kobiet i mężczyzn - Iza Miętka<br></br>
              2026 - diagnoza z pulsu - Paweł Skrzypczak
            </p>
            <p style={{marginTop: 0}}><span className='italic'>Dodatkowe szkolenia:</span> Diagnoza (Yair Maimon), lokalizacja punktów akupunkturowych, diagnoza z pulsu (Bartosz Chmielnicki), moxa i akupunktura czaszki (Suzzanne Robidoux), Masaż Gua Sha (Donald B. Halfkenny)</p>

          </Col>
          
          
        </Row>
        <Row className='o-mnie-edu-joga'>
           <Col xs={12} md={6}>
            <p><span className='border-btm'>Joga:</span></p>
            <p style={{marginTop: 0}}>Pierwsze kroki na macie stawiałam w 2008r. Joga stała się regularną praktyką od 2012 r., nauczam od 2015 r. Moją praktykę zaczęłam od metody Iyengara (która nauczyła świadomie budować pozycje), następnie Ashtanga Vinyasa Yoga, dzięki której mogłam samodzielnie praktykować w domu, następnie pojawiła się Sivananda Yoga (w tej metodzie ukończyłam kurs nauczycielski), która zafascynowała mnie zintegrowanym podejściem i traktowaniem Jogi jako ścieżki samopoznania, pozwoliła zanurzyć się bardziej w filozofię Jogi i jej medytacyjny aspekt. Moje zajęcia to połączenie mądrości tradycji z nowoczesnym podejściem. Nierzadko na zajęciach pojawiają się elementy ćwiczeń funkcjonalnych, ćwiczeń regulujących układ nerwowy z tradycyjnymi asanami i ćwiczeniami oddechowymi (pranajamy).</p>
            </Col>         
            <Col xs={12} md={6}>
            <p style={{marginTop: 30}}>
              2015 - Instruktor Zajęć Psychofizycznych - Joga (Efib)<br></br>
              2016 - Indie, Kerala - Sivananda Yoga Vedanta<br></br>
              2017 - Fizjoterapeutyczne Aspekty Jogi - Mateusz Stańczak<br></br>
              2017 - Międzynarodowy Kurs Nauczycielski Jogi Sivanandy (200hrs Yoga Alliance TTC)<br></br>
              2017 - Joga w Ciąży (Agnieszka Bera Shakti Doula Copenhagen)<br></br>
              2019 - Indie (Goa) - Balu<br></br>
              2026 - kurs Pranayama - dr. Nina Budziszewska
            </p>
            </Col>
        </Row>
      </Container>
      </FadeIn>

      <FadeIn>
      <Container className='tagline-text' id='kontakt'>
        <Row>
          <Col xs={12} md={12}>
            <p className='tagline'>Zadbaj o swoje zdrowie i dobre samopoczucie</p>
            <p className='smaller-tagline'>Umów pierwszą wizytę lub zapisz się na zajęcia jogi.</p>
            <a href="https://kulczynska-trzeciak.pl/grafik/" className='btn btn-primary'>Umów wizytę</a>
          </Col>
        </Row>
      </Container>
      </FadeIn>

      <FadeIn>
    <Container className='contact' >
      <Col xs={12} md={12}>
 
    </Col>
      <Row>
        <Col md={4} className='section'>
        <h1 className='less-gigantic section-title stacked desktop-only'>
        
        <span className="g-italic">KON<br></br>TAKT</span>
        </h1>
        <h1 className='less-gigantic section-title stacked mobile-only'>
        
        <span className="g-italic">KONTAKT</span>
        </h1>
        </Col>
        <Col md={4}>
          <p>Weronika Kulczyńska-Trzeciak<br></br> <br></br> 
          <a href="tel:609 077 780">609 077 780</a><br></br> <a href="mailto:weronika.uzdrowisko@gmail.com">weronika.uzdrowisko@gmail.com</a></p>
          <div className='social-icons-row'>
            <a href="https://www.instagram.com/weronika_akupunktura_joga" target="_blank" rel="noopener noreferrer" aria-label="Instagram @weronika_akupunktura_joga">
              <svg viewBox="0 0 24 24" width="32" height="32" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.9.9 1.4.2.4.4 1.1.4 2.2.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.9.7-1.4.9-.4.2-1.1.4-2.2.4-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-1.8-.2-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.9-.9-1.4-.2-.4-.4-1.1-.4-2.2-.1-1.3-.1-1.6-.1-4.8s0-3.6.1-4.8c.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.9-.7 1.4-.9.4-.2 1.1-.4 2.2-.4 1.2-.1 1.6-.1 4.8-.1M12 0C8.7 0 8.3 0 7.1.1 5.8.1 4.9.3 4.1.6c-.8.3-1.5.7-2.1 1.4C1.3 2.6.9 3.3.6 4.1.3 4.9.1 5.8.1 7.1 0 8.3 0 8.7 0 12s0 3.7.1 4.9c.1 1.3.3 2.2.6 2.9.3.8.7 1.5 1.4 2.1.7.7 1.3 1.1 2.1 1.4.8.3 1.6.5 2.9.6 1.2.1 1.6.1 4.9.1s3.7 0 4.9-.1c1.3-.1 2.2-.3 2.9-.6.8-.3 1.5-.7 2.1-1.4.7-.7 1.1-1.3 1.4-2.1.3-.8.5-1.6.6-2.9.1-1.2.1-1.6.1-4.9s0-3.7-.1-4.9c-.1-1.3-.3-2.2-.6-2.9-.3-.8-.7-1.5-1.4-2.1C21.4 1.3 20.7.9 19.9.6 19.1.3 18.2.1 16.9.1 15.7 0 15.3 0 12 0zm0 5.8a6.2 6.2 0 1 0 0 12.4 6.2 6.2 0 0 0 0-12.4zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.4-11.8a1.4 1.4 0 1 0 0 2.9 1.4 1.4 0 0 0 0-2.9z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/Weronika.Akupunktura.Joga" target="_blank" rel="noopener noreferrer" aria-label="Facebook Weronika.Akupunktura.Joga">
              <svg viewBox="0 0 24 24" width="32" height="32" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M24 12.07C24 5.41 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.5h-2.8V24C19.62 23.1 24 18.1 24 12.07z"/>
              </svg>
            </a>
          </div>
        </Col>
        <Col md={4}>
          <p>Gabinety</p>
          <p>Ul. Naramowicka 240, Poznań<br></br>
(1 piętro)</p>
          <p style={{marginTop: 0}}>Ul. Wierzbięcice 34, Poznań</p>
        </Col>
      </Row>

    </Container>
      </FadeIn>
    </div>
  );
}

export default App;